import * as React from "react";
import { ReactNode } from "react";
import classNames from "classnames";

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

export function Heading({
  className,
  title,
  subline,
  children,
  level = 2,
  textAlign = "center",
  ...props
}: Omit<
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
  "title"
> & {
  title: ReactNode;
  subline?: ReactNode;
  textAlign?: "left" | "center" | "right" | false;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}) {
  const Tag = `h${level}` as `h${HeadingLevel}`;
  return (
    <Tag
      className={classNames(
        {
          "text-left": textAlign === "left",
          "text-center": textAlign === "center",
          "text-right": textAlign === "right",
        },
        className,
      )}
      {...props}
    >
      <span
        className={classNames("block text-4xl font-bold text-primary", {
          uppercase: level === 1,
        })}
      >
        {title}
      </span>
      {subline && <span className={"block text-2xl"}>{subline}</span>}
      {children}
    </Tag>
  );
}
